import React from 'react';
import { Field } from 'formik';
import { observer } from 'mobx-react-lite';
import { searchStore } from 'stores';
import { PENDING } from 'constants/actions';
import { useTranslation } from 'hooks';
import Type from 'prop-types';
import AsyncAutocompleteField from '../../Form/AsyncAutocompleteField';

const ConstructionSearch = observer((props) => {
  const { constructions, constructionsFetchState } = searchStore;
  const { disabled } = props;
  const { t } = useTranslation();

  const getOptions = (searchQuery) => {
    searchStore.getConstructions({ query: searchQuery });
  };

  return (
    <Field
      name="construction"
      filterOptions={(x) => x}
      component={AsyncAutocompleteField}
      getOptionLabel={(option) => option.name}
      options={constructions}
      loading={constructionsFetchState === PENDING}
      getOptions={getOptions}
      textFieldProps={{
        label: t('construction'),
        margin: 'normal',
        ...props.textFieldProps,
      }}
      disabled={disabled}
    />
  );
});

ConstructionSearch.propTypes = {
  isAssignee: Type.bool,
};

ConstructionSearch.defaultProps = {
  isAssignee: false,
};

export default ConstructionSearch;
